import React from 'react';
import './FooterNavigation.scss';
import Button from '../Button/Button';
import Label from '../Label/Label';
import {closeModal, closeTier3ModalEvent} from '../../utils/tier-3-modal-close/PrequalCloseEvent';
import {addressValidationService} from '../../Services/AddressValidationService/AddressValidationService';

export async function compareStandardizedAddress(customerData, appConfig) {
  let validatedAddress = '';
  let addressIsEqual = false;
  let isApiDown = false;
  const postData = async () => {
    const response = await addressValidationService(customerData, appConfig).catch(() => {
      isApiDown = true;
    });
    validatedAddress = response?.data;
    if (validatedAddress?.streetAddress === customerData?.streetAddress.value || isApiDown) {
      addressIsEqual = true;
    }
  };
  await postData();
  return addressIsEqual;
}

export function closeEvent(customerData, dispatch) {
  customerData.isDealerHostApplication.value ? closeTier3ModalEvent({}, dispatch, customerData) : closeModal(dispatch, customerData);
}
function FooterNavigation({props, customerData}) {
  return (
    <>
      <div
        className={`prequal--web--footer-button-container ${customerData.isDealerHostApplication.value ? 'prequal--web--footer-tier3-button-container' : ''}`}
      >
        <button
          type='button'
          onClick={props.closeButtonOnClickEvent}
          className='prequal--web--footer-close-button'
          data-testid='footerNavCloseButton'
        >
          <Label content='Close' labelType='bold' dataTestId='closeButton' />
        </button>
        <Button
          id='prequal--web--footer--primary-button'
          label={props.primaryButtonLabel}
          buttonStyle='primary'
          dataTestId={props.primaryButtonTestId}
          onClick={props.primaryButtonOnClickEvent}
          className='prequal--web--footer-primary-button'
          looksDisabled={!props.buttonIsDisabled}
        />
      </div>
    </>
  );
}

export default FooterNavigation;
